/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TaxCategoriesTaxCategoryIdDelete$Params {
  'Active-Tenant-Identifier': string;
  taxCategoryId: string;
}

export function taxCategoriesTaxCategoryIdDelete(http: HttpClient, rootUrl: string, params: TaxCategoriesTaxCategoryIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesTaxCategoryIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('taxCategoryId', params.taxCategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

taxCategoriesTaxCategoryIdDelete.PATH = '/tax-categories/{taxCategoryId}';
